import { call, put } from 'redux-saga/effects';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  loadReconciliationHeaderSuccess,
  loadReconciliationHeaderFailure,
} from '../actions';
import {
  loadReconciliationHeader,
  LoadReconciliationHeaderResponse,
} from '../api';
import { LoadReconciliationHeaderRequestAction } from '../types';

export function* loadReconciliationHeaderSaga(
  action: LoadReconciliationHeaderRequestAction
) {
  try {
    const { connectionId, toDate } = action.payload;

    const response: LoadReconciliationHeaderResponse = yield call(
      loadReconciliationHeader,
      connectionId,
      toDate
    );
    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(loadReconciliationHeaderSuccess(response.data));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(loadReconciliationHeaderFailure());
  }
}
